import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initTelegram } from './lib/telegram.js';
import './styles.css';

// Настройка клиента не должна мешать приложению открыться: любая ошибка
// здесь стоит потери оформления, но не белого экрана.
try {
  initTelegram();
} catch (err) {
  console.error('[telegram] инициализация не удалась:', err);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
